<template>
  <div class="staff-StaffSelector">
    <template v-if="disabled">
      <AssessmentInfo :ids="findStaff.map(o => o.id)" :option='option' />
      <!-- <span
        v-else
        class="text-primary"
      >
        {{ findStaff.map(o => o.enName).join() }}
      </span> -->
    </template>
    <div v-else class="staff-StaffSelector_content" @click="handleVisible">
      <!-- 已选中员工 -->
      <span v-if="value && value !== -1 && value !== '-1'" class="hasValue">
        <!-- 选择器为多选时，选中人员展示 -->
        <div v-if="multiple" style="width: calc(100% - 50px);">
          <a-tag v-for="(item, i) in findStaff" :key="i" closable class="mt-0-5"
            @close="delCheckedStaff($event, item.id)">
            {{ item.enName }}
          </a-tag>
        </div>
        <!-- 选择器为单选时，选中人员展示 -->
        <span v-else>{{ findStaff.map(o => o.enName).join() }}</span>
        <feather-icon icon="XCircleIcon" class="hasValue-icon" size="16" @click.stop="clearValue" />
        <feather-icon icon="ChevronDownIcon" class="placeholder-icon" size="20" />
      </span>
      <!-- 未选中员工 -->
      <span v-else class="placeholder">
        <span>{{ placeholder }}</span>

        <feather-icon icon="ChevronDownIcon" class="placeholder-icon" size="20" />
      </span>
    </div>

    <!-- 员工选择器 -->
    <c-modal :visible="visible" title="Staff selector" size="lg"
      body-class="staff-selector-modal_body" footer-class="staff-selector-modal_footer"
      @close="close" @modelConfirm="handleModelConfirm" @confirmEnter="hoverConfirm = true"
      @confirmLeave="hoverConfirm = false">
      <template slot="content">
        <div class="selector-content">
          <!-- 人员选择器Tab分栏 -->
          <b-tabs v-model="currentTab" align="left">
            <b-tab :title="i18n('selector.recently')" />
            <b-tab :title="i18n('selector.businessSection')">
              <b-overlay :show="businessLoading" rounded="sm" class="overlay-box my-border"
                :class="{'my-border__hover': businessLoaded}">
                <tree-list :data="businessTreeData" :props="deptProps"
                  @checkItem="handlebusinessChcek" />
              </b-overlay>
            </b-tab>
            <b-tab :title="i18n('selector.dept')">
              <b-overlay :show="deptLoading" rounded="sm" class="overlay-box my-border"
                :class="{'my-border__hover': deptLoaded}">
                <tree-list :data="departmentTreeData" :props="deptProps"
                  @checkItem="handleDeptChcek" />
              </b-overlay>
            </b-tab>
            <b-tab :title="i18n('selector.team')">
              <b-overlay :show="teamLoading" rounded="sm" class="overlay-box my-border"
                :class="{'my-border__hover': teamLoaded}">
                <tree-list :data="teamTreeData" :props="deptProps"
                  :handle-disabled="handleTeamDisabled" @checkItem="handleteamChcek" />
              </b-overlay>
            </b-tab>
            <!-- <b-tab :title="i18n('selector.post')" /> -->
            <b-tab :title="i18n('selector.project')">
              <b-overlay :show="projectLoading" rounded="sm" class="overlay-box my-border"
                :class="{'my-border__hover': projectLoaded}">
                <tree-list :data="projectTreeData" :props="projectProps"
                  @checkItem="handleprojectChcek" />
              </b-overlay>
            </b-tab>
          </b-tabs>
          <!--  -->
          <!-- 分栏Tab的公共显示区域 -->
          <!--  -->
          <div class="staff-search">
            <b-form-input v-model="searchStaff"
              :placeholder="$t('_components.placeholder.input')+ 'staff or number'" type="text" />
            <b-button variant="primary" size="sm" @click="handleSearchStaff">
              {{ i18n('btns.search') }}
            </b-button>
          </div>
          <!-- 员工查询列表 -->
          <div class="staff-list my-border"
            :class="{'staff-list__maxheight': currentTab === 0, 'my-border__hover': staffLoaded}">
            <template v-for="(item, i) in staffData">
              <b-form-checkbox v-if="multiple" :key="i" v-model="chcekedStaff"
                class="staff-list__item"
                :class="{'staff-list__item-checked': !!chcekedStaffResult.find(o => o.id === item.id)}"
                :value="item.id">
                {{ item.enName }}
              </b-form-checkbox>
              <div v-else :key="i" class="staff-list__item"
                :class="{'staff-list__item-checked': chcekedStaff.indexOf(item.id) != -1}"
                @click="handleStaffClick(item)">
                {{ item.enName }}
              </div>
            </template>

          </div>
          <!-- 选中员工列表 -->
          <div class="checked-staff my-border"
            :class="hoverConfirm ? (chcekedStaffResult.length>0 ? 'my-border__hover' : 'my-border__hover-wrning') : ''">
            <!-- 操作按钮（控制是否选中） -->
            <div class="checked-staff__btns">
              <div :class="chcekedStaff.length>0 ? 'not-disabled':'is-disabled'"
                @click="handleMoveRes">
                <feather-icon icon="ChevronRightIcon" size="20" />
              </div>
              <div :class="chcekedResStaff.length>0 ? 'not-disabled':'is-disabled'"
                @click="handleClearRes">
                <feather-icon icon="ChevronLeftIcon" size="20" />
              </div>
            </div>
            <!-- 选中员工的数据展示 -->
            <div class="checked-staff__content">
              <template v-for="(item, i) in chcekedStaffResult">
                <b-form-checkbox v-if="multiple" :key="i" v-model="chcekedResStaff"
                  class="staff-list__item" :value="item.id">
                  {{ item.enName }}
                </b-form-checkbox>
                <div v-else :key="i" class="staff-list__item"
                  :class="{'staff-list__item-checked': chcekedResStaff.indexOf(item.id) != -1}"
                  @click="handleResStaffClick(item)">
                  {{ item.enName }}
                </div>
              </template>
            </div>
          </div>
        </div>
      </template>
    </c-modal>
  </div>
</template>

<script>
import TreeList from '@/components/treeList.vue';
import {
  BTab,
  BTabs,
  BOverlay,
  BFormCheckbox,
  BFormInput,
  BButton,
} from 'bootstrap-vue';
import { deptTree, getList as getDeptList } from '@/api/system/dept';
import { mapGetters } from 'vuex';
import { staff } from '@/api/staff/index';
import projectAPI from '@/api/base/project';
import { getStore, setStore } from '@/util/store';
import AssessmentInfo from './AssessmentInfo.vue';

export default {
  components: {
    CModal: () => import('@/components/crud/modal.vue'),
    BTab,
    BTabs,
    TreeList,
    BOverlay,
    BFormCheckbox,
    BFormInput,
    BButton,
    AssessmentInfo,
  },
  props: {
    value: {
      type: [String, Number, Object, Array, Boolean],
      default: undefined,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentTab: 2,
      visible: false,
      searchStaff: '',
      // dept 相关参数
      checkedDept: '',
      deptLoaded: false,
      departmentTreeData: [],
      deptLoading: false,
      // team 相关参数
      checkedteam: '',
      teamLoaded: false,
      teamTreeData: [],
      teamLoading: false,
      // businessSection 相关参数
      checkedbusiness: '',
      businessLoaded: false,
      businessTreeData: [],
      businessLoading: false,
      // project 相关参数
      checkedproject: '',
      projectLoaded: false,
      projectTreeData: [],
      projectLoading: false,
      // 选中员工 相关参数
      chcekedStaff: [],
      chcekedStaffResult: [],
      chcekedResStaff: [],
      checkedStaffData: [],
      // 查询员工参数
      staffData: [],

      hoverConfirm: false,
      staffLoaded: false,
      multiple: false,

      query: this.option.dictQuery,
    };
  },
  computed: {
    ...mapGetters(['language', 'recentlyUser']),
    saveKey() {
      return this.option.saveKey ? this.option.saveKey : 'id';
    },
    placeholder() {
      return this.option.placeholder
        ? this.option.placeholder
        : this.$t('_components.placeholder.input') + this.label;
    },
    deptProps() {
      return {
        label: 'deptName',
        value: 'id',
        children: 'children',
      };
    },
    projectProps() {
      return {
        label: 'projectName',
        value: 'id',
        children: 'children',
      };
    },
    findStaff() {
      let find = [];
      if (this.value && this.value !== -1 && this.value !== '-1') {
        const valArr = this.value.split(',');
        find =
          this.checkedStaffData.filter(
            (o) => valArr.indexOf(o[this.saveKey].toString()) !== -1
          ) || [];
        if (find.length <= 0) {
          find =
            this.staffData.filter(
              (o) => valArr.indexOf(o[this.saveKey].toString()) !== -1
            ) || [];
        }
      }
      return find;
    },
    recentlyStaff() {
      return this.recentlyUser.staff || [];
    },
  },
  watch: {
    value(e) {},
    currentTab: {
      deep: true,
      handler(e) {
        this.onload();
      },
    },
    // disabled: {
    //   immediate: true,
    //   handler(e) {
    //     if (e) {
    //       staff.easyList(1, -1, this.query).then(res => {
    //         const temp = res.data.data.records
    //         this.staffData = temp
    //         this.staffLoaded = true
    //         setTimeout(() => {
    //           this.staffLoaded = false
    //         }, 500);
    //       })
    //     }
    //   },
    // },
    'option.multiple': {
      handler(e) {
        this.multiple = e || false;
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    if (
      this.value &&
      this.staffData.length <= 0 &&
      this.value !== -1 &&
      this.value !== '-1'
    ) {
      staff.easyList(1, -1, { ids: this.value, ...this.query }).then((res) => {
        const temp = res.data.data.records;
        this.staffData = temp;
        const valArr = this.value.split(',');
        this.chcekedStaffResult =
          temp.filter((o) => valArr.indexOf(o.id.toString()) !== -1) || [];
        this.staffLoaded = true;
        setStore({
          name: `dictsStaticData-staff-${this.value}`,
          content: this.chcekedStaffResult,
        });
        setTimeout(() => {
          this.staffLoaded = false;
        }, 500);
      });
    }
  },
  methods: {
    handleVisible() {
      this.visible = true;
      this.onload();
      staff.easyList(1, -1, this.query).then((res) => {
        const temp = res.data.data.records;
        this.staffData = temp;
        this.staffLoaded = true;
        setTimeout(() => {
          this.staffLoaded = false;
        }, 500);
      });
    },
    onload() {
      if (this.currentTab === 0) {
        this.staffData = [...this.recentlyStaff];
      } else if (this.currentTab === 1) {
        if (this.businessTreeData.length <= 0) {
          this.businessLoading = true;
          const businessParams = {
            parentId: '1123598813738675201',
          };
          getDeptList(1, -1, businessParams).then((res) => {
            this.businessTreeData = res.data.data;
            this.businessLoading = false;
            this.businessLoaded = true;
            setTimeout(() => {
              this.businessLoaded = false;
            }, 500);
          });
        } else if (this.checkedbusiness) {
          this.handlebusinessChcek(this.checkedbusiness);
        }
      } else if (this.currentTab === 2) {
        if (this.departmentTreeData.length <= 0) {
          this.deptLoading = true;
          const deptParams = {
            deptCategory: '2',
            parentId: '1123598813738675201',
          };
          deptTree(deptParams).then((res) => {
            this.departmentTreeData = res.data.data;
            this.deptLoading = false;
            this.deptLoaded = true;
            setTimeout(() => {
              this.deptLoaded = false;
            }, 500);
          });
        } else if (this.checkedDept) {
          this.handleDeptChcek(this.checkedDept);
        }
      } else if (this.currentTab === 3) {
        if (this.teamTreeData.length <= 0) {
          this.teamLoading = true;
          const teamParams = {
            deptType: '3',
            deptCategory: '2',
            parentId: '1123598813738675201',
          };
          deptTree(teamParams).then((res) => {
            this.teamTreeData = res.data.data;
            this.teamLoading = false;
            this.teamLoaded = true;
            setTimeout(() => {
              this.teamLoaded = false;
            }, 500);
          });
        } else if (this.checkedteam) {
          this.handleteamChcek(this.checkedteam);
        }
      } else if (this.currentTab === 4) {
        if (this.projectTreeData.length <= 0) {
          this.projectLoading = true;
          projectAPI.getList(1, -1).then((res) => {
            this.projectTreeData = res.data.data.records;
            this.projectLoading = false;
            this.projectLoaded = true;
            setTimeout(() => {
              this.projectLoaded = false;
            }, 500);
          });
        } else if (this.checkedproject) {
          this.handleprojectChcek(this.checkedproject);
        }
      }
    },
    handleDeptChcek(e) {
      this.checkedDept = typeof e === 'object' ? e.id : e;
      staff
        .easyList(1, -1, { deptId: this.checkedDept, ...this.query })
        .then((res) => {
          const temp = res.data.data.records;
          this.staffData = temp;
          this.staffLoaded = true;
          setTimeout(() => {
            this.staffLoaded = false;
          }, 500);
        });
    },
    handleteamChcek(e) {
      this.checkedteam = typeof e === 'object' ? e.id : e;
      staff
        .easyList(1, -1, { teamId: this.checkedteam, ...this.query })
        .then((res) => {
          const temp = res.data.data.records;
          this.staffData = temp;
          this.staffLoaded = true;
          setTimeout(() => {
            this.staffLoaded = false;
          }, 500);
        });
    },
    handlebusinessChcek(e) {
      this.checkedbusiness = typeof e === 'object' ? e.id : e;
      staff
        .easyList(1, -1, {
          businessSectionId: this.checkedbusiness,
          ...this.query,
        })
        .then((res) => {
          const temp = res.data.data.records;
          this.staffData = temp;
          this.staffLoaded = true;
          setTimeout(() => {
            this.staffLoaded = false;
          }, 500);
        });
    },
    handleprojectChcek(e) {
      this.checkedproject = typeof e === 'object' ? e.id : e;
      staff
        .easyList(1, -1, { projectId: this.checkedproject, ...this.query })
        .then((res) => {
          const temp = res.data.data.records;
          this.staffData = temp;
          this.staffLoaded = true;
          setTimeout(() => {
            this.staffLoaded = false;
          }, 500);
        });
    },
    handleStaffClick(e) {
      this.chcekedStaff = [e.id];
    },
    handleResStaffClick(e) {
      this.chcekedResStaff = [e.id];
    },
    handleModelConfirm() {
      this.visible = false;
      this.checkedStaffData = this.chcekedStaffResult;
      const res = this.chcekedStaffResult.map((o) => o[this.saveKey]).join();

      const { recentlyStaff } = this;
      this.chcekedStaffResult.forEach((item) => {
        if (!recentlyStaff.find((o) => o.id === item.id)) {
          recentlyStaff.push(item);
        }
      });
      const temp = this.recentlyUser;
      temp.staff = recentlyStaff;
      this.$store.commit('SET_RECENTLY_USER', temp);

      this.$emit('input', res);
    },
    delCheckedStaff(e, id) {
      e.preventDefault();
      const temp = [];
      this.chcekedStaffResult.forEach((item) => {
        if (item.id !== id) {
          temp.push(item);
        }
      });
      this.chcekedStaffResult = [...temp];
      const res = temp.map((o) => o.id).join();
      this.$emit('input', res);
    },
    handleMoveRes() {
      const filter = this.staffData.filter(
        (o) => this.chcekedStaff.indexOf(o.id) !== -1
      );
      if (!this.multiple) {
        this.chcekedStaffResult = [...filter];
      } else {
        const temp = [...this.chcekedStaffResult];
        filter.forEach((item) => {
          if (!temp.find((o) => o.id === item.id)) {
            temp.push(item);
          }
        });
        this.chcekedStaffResult = temp;
      }
      this.chcekedStaff = [];
      this.hoverConfirm = true;
      setTimeout(() => {
        this.hoverConfirm = false;
      }, 500);
    },
    handleClearRes() {
      const temp = [];
      this.chcekedStaffResult.forEach((item) => {
        if (this.chcekedResStaff.indexOf(item.id) === -1) {
          temp.push(item);
        }
      });
      this.chcekedStaffResult = temp;
      this.chcekedResStaff = [];
      this.hoverConfirm = true;
      setTimeout(() => {
        this.hoverConfirm = false;
      }, 500);
    },
    close() {
      this.visible = false;
      this.hoverConfirm = false;
    },
    clearValue() {
      this.chcekedStaffResult = [];
      this.chcekedResStaff = [];
      this.$emit('input', '');
    },
    handleTeamDisabled(e) {
      return e.deptType !== 3;
    },
    // 国际化
    i18n(param) {
      return this.$t(`_components.${param}`);
    },
    handleSearchStaff() {
      staff
        .easyList(1, -1, { nameOrNo: this.searchStaff, ...this.query })
        .then((res) => {
          const temp = res.data.data.records;
          this.staffData = temp;
          this.staffLoaded = true;
          setTimeout(() => {
            this.staffLoaded = false;
          }, 500);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.staff-StaffSelector {
  padding: 0 2px;
  width: 100%;
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  font-feature-settings: 'tnum';
  position: relative;
  display: inline-block;
  outline: 0;
  &_content {
    display: block;
    cursor: pointer;
    padding: 0 15px 0 11px;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-top: 1.02px solid #d9d9d9;
    border-radius: 4px;
    outline: none;
    user-select: none;
    min-height: 2.714rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 2.714rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s;
    &:hover {
      box-shadow: 0 0 0 2px rgb(24 144 255 / 20%);
    }

    .placeholder,
    .hasValue {
      display: inline-block;
      position: relative;
      width: 100%;
      line-height: 20px;
      &-icon {
        position: absolute;
        color: #bfbfbf;
        right: 0;
        top: 50%;
        transform: translateY(calc(-50% + 2px));
        background-color: #fff;
        z-index: 1;
      }
    }
    .placeholder {
      color: #bfbfbf;
    }
    .hasValue {
      color: rgba(0, 0, 0, 0.65);
      &-icon {
        color: #fff;
        transition: color 0.3s;
      }
    }
    &:hover {
      .hasValue {
        &-icon {
          color: #bfbfbf;
          transition: color 0.3s;
          z-index: 2;
          &:hover {
            color: #797979;
          }
        }
      }
    }
  }
}
.selector-content {
  height: 500px;
  .overlay-box {
    height: 200px;
    width: calc(100% - 15px);
    overflow: auto;
    background-color: #fff;
    padding: 5px 8px;
  }
  .tab-pane {
    width: 50%;
  }
  .staff-search {
    width: calc(50% - 15px);
    margin: 5px 0;
    display: flex;
    .btn {
      margin-left: 5px;
    }
  }
  .staff-list {
    height: 200px;
    width: calc(50% - 15px);
    overflow: auto;
    background-color: #fff;
    padding: 5px 4px;
    &__item {
      padding: 0 4px;
      margin: 2px 0;
      border-radius: 5px;
      &:hover,
      &-checked {
        background-color: #eee;
        cursor: pointer;
      }
      &-checked {
        color: #409eff;
        background-color: #cae1fc !important;
      }
    }
    &__maxheight {
      height: 406px;
    }
  }
  .checked-staff {
    height: calc(100% - 71px);
    width: calc(50% - 28px);
    background-color: #fff;
    padding: 5px 4px;
    position: absolute;
    left: calc(50% + 15px);
    top: 61px;
    &__btns {
      position: absolute;
      top: 50%;
      left: -25px;
      transform: translateY(-50%);
      width: 20px;
      & > div {
        width: 100%;
        border-radius: 5px;
        border: 1px solid #ddd;
        background-color: #fff;
        padding: 5px 0;
        cursor: not-allowed;
      }
      & > div:first-child {
        margin-bottom: 10px;
      }
      .not-disabled {
        background-color: #409eff;
        color: #fff;
        cursor: pointer;
        &:hover {
          background-color: #78aff9;
        }
      }
      .is-disabled {
        cursor: not-allowed;
      }
    }
    &__content {
      height: 100%;
      overflow: auto;
      padding: 5px 4px;
    }
    &::before {
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      border: 1px solid #ddd;
      border-radius: 5px;
      z-index: -1;
    }
  }
}
.my-border {
  border-radius: 5px;
  border: 1px solid #ddd;
  transition: border-color 0.15s ease-in-out, box-shadow 0.3s;
  &__hover {
    border: 1px solid #fff !important;
    box-shadow: 0 0 0 4px rgb(24 144 255 / 30%);
  }
  &__hover-wrning {
    box-shadow: 0 0 0 4px rgb(230 162 61 / 30%);
  }
}
.mt-0-5 {
  margin-top: 0.5rem;
}
</style>
<style lang="scss">
.staff-selector-modal_body {
  background-color: #eee;
  padding: 0.8rem 0.8rem !important;
  .custom-control.custom-checkbox {
    padding-left: 1.8rem;
  }
  .custom-control-label {
    cursor: pointer;
    width: 100%;
  }
}
</style>
